import { useSyncExternalStore } from 'react'

// Store functions
const subscribe = (callback: () => void) => {
	window.addEventListener('storage', callback)
	return () => window.removeEventListener('storage', callback)
}

const getSnapshot = () => {
	if (typeof window === 'undefined') return false
	return !localStorage.getItem('locale_banner_seen')
}

const getServerSnapshot = () => false

export function useLocaleBanner() {
	const showBanner = useSyncExternalStore(
		subscribe,
		getSnapshot,
		getServerSnapshot,
	)
	return showBanner
}
